import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الشحنة الكهربائية - حساب مقدار الشحنة الكهربائية";
const DESCRIPTION =
  "حاسبة الشحنة الكهربائية تستخدم لحساب مقدار الشحنة الكهربائية على كرتين مشحونتين باستخدام قانون كولوم للتفاعلات الكهربائية.";
const KEYWORDS = "الشحنة الكهربائية, قانون كولوم, حساب الشحنة الكهربائية";
const OG_URL = "https://do-calculate.com/calculator/ar/electric-charge";
function ElectricChargeCalculator() {
  const [force, setForce] = useState("");
  const [distance, setDistance] = useState("");
  const [chargeMagnitude, setChargeMagnitude] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!force || !distance) {
      setError("الرجاء إدخال القوة والمسافة بشكل صحيح");
      setChargeMagnitude("");
      return;
    }
    const electrostaticConstant = 8.99e9;
    const forceValue = parseFloat(force);
    const distanceValue = parseFloat(distance);
    if (isNaN(forceValue) || isNaN(distanceValue)) {
      setError("الرجاء إدخال قيم صحيحة للأرقام");
      setChargeMagnitude("");
      return;
    }
    const chargeMagnitudeValue = Math.sqrt(
      (forceValue * distanceValue ** 2) / electrostaticConstant
    );
    setChargeMagnitude(
      `قوة التفاعل بين الشحنات: ${forceValue} نيوتن <br/>
            المسافة بين الشحنات: ${distanceValue} متر <br/>
            الشحنة الكهربائية على كل كرت: ${chargeMagnitudeValue.toFixed(
              2
            )} كولوم <br/>
            (ملاحظة: تم حساب الشحنة بناءً على قانون كولوم للتفاعلات الكهربائية)`
    );
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>
                  كيفية حساب الشحنة الكهربائية
                </h2>
                <p>
                  يمكنك استخدام هذه الحاسبة لحساب مقدار الشحنة الكهربائية على
                  كرتين مشحونتين باستخدام قانون كولوم للتفاعلات الكهربائية.
                </p>
                <p>
                  القوة = (الثابت الكهروستاتي × |الشحنة الأولى × الشحنة
                  الثانية|) / (المسافة^2)
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">القوة (نيوتن)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="قوة التفاعل"
                        value={force}
                        onChange={(e) => setForce(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">المسافة (متر)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="المسافة بين الشحنات"
                        value={distance}
                        onChange={(e) => setDistance(e.target.value)}
                        className="form-control"
                        style={{ width: "200px" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب الشحنة الكهربائية
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {chargeMagnitude !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              النتيجة:
                            </p>
                            <p
                              className="p-3 mb-2 bg-info text-black"
                              dangerouslySetInnerHTML={{
                                __html: chargeMagnitude,
                              }}
                            ></p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default ElectricChargeCalculator;
